"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactUsPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var colors_config_1 = __importDefault(require("../../../colors.config"));
var send_generic_email_1 = require("../../api/calls/notification/send_generic_email");
var main_1 = require("../../reducers/slices/main");
var react_redux_1 = require("react-redux");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_router_dom_1 = require("react-router-dom");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var ContactUsPage = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var canvasRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(""), name = _a[0], setName = _a[1];
    var _b = (0, react_1.useState)(""), email = _b[0], setEmail = _b[1];
    var _c = (0, react_1.useState)(""), message = _c[0], setMessage = _c[1];
    var _d = (0, react_1.useState)(""), nameError = _d[0], setNameError = _d[1];
    var _e = (0, react_1.useState)(""), emailError = _e[0], setEmailError = _e[1];
    var _f = (0, react_1.useState)(""), messageError = _f[0], setMessageError = _f[1];
    var _g = (0, react_1.useState)(false), isButtonLoading = _g[0], setIsButtonLoading = _g[1];
    var validate = function () {
        var regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        var messageCount = 0;
        if (!name) {
            messageCount++;
            setNameError("Name is required!");
        }
        if (email) {
            var isValidEmail = regex.test(email);
            if (!isValidEmail) {
                messageCount++;
                setEmailError("Invalid email address!");
            }
        }
        else {
            messageCount++;
            setEmailError("Email address is required!");
        }
        if (!message) {
            messageCount++;
            setMessageError("Message is required!");
        }
        return messageCount ? false : true;
    };
    (0, react_1.useEffect)(function () {
        var canvas = canvasRef.current;
        if (canvas) {
            var context = canvas.getContext("2d");
            context.fillStyle = "#000000";
            context.filter = "blur(0px)";
            context.shadowColor = "#ff0000";
            context.shadowBlur = 0;
            context.fillRect(0, 0, context.canvas.width, 10);
        }
    }, []);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement("div", { className: "relative" },
            react_1.default.createElement("div", { className: "flex flex-row justify-center" },
                react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
                    react_1.default.createElement("div", { className: "flex flex-col items-center" },
                        react_1.default.createElement("div", { className: "w-[400px] md:w-[600px] lg:w-[800px] flex flex-col gap-y-4 p-8" },
                            react_1.default.createElement("div", { className: "py-20 flex flex-col items-center gap-8" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Contact Our Team", size: "3xlarge", textColor: "text-tertiary", center: true }),
                                react_1.default.createElement("div", { className: "flex flex-col pt-4 pb-4 gap-1 justify-center items-center " },
                                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "If you have any concerns, comments or queries, our team is standing by and ready to assist you. If you're searching for  quick answers to a common questions. ", size: "medium", textColor: "text-tertiary", center: true }),
                                    react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "You can also have a look at our: FAQs page", size: "medium", textColor: "text-tertiary", onClick: function () {
                                            navigate("/faqs");
                                        } }))),
                            react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "bg-white shadow-md", variant: "filled", addPadding: false },
                                react_1.default.createElement("div", { className: "flex flex-col gap-4  p-8 " },
                                    react_1.default.createElement("div", { className: "grid gap-4 grid-cols-1 lg:grid-cols-2" },
                                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Your Name", value: name, onChange: function (v) { return setName(v); }, errorText: nameError, required: true }),
                                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Contact Email", value: email, onChange: function (v) { return setEmail(v); }, errorText: emailError, required: true })),
                                    react_1.default.createElement("div", { className: "lg:col-span-2" },
                                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Your message here", lines: 8, borderColor: "border-borders", value: message, errorText: messageError, required: true, onChange: function (v) {
                                                setMessage(v);
                                            } })),
                                    react_1.default.createElement("div", { className: "flex pt-4 pb-4 gap-1" },
                                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "By submitting the form you agree to our", size: "xsmall" }),
                                        react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Privacy Policy", size: "xsmall", onClick: function () {
                                                navigate("/privacy-policy");
                                                // const link = document.createElement("a");
                                                // link.href = `/docs/SKY_APP_PRIVACY_POLICY.pdf`;
                                                // link.target = "_blank"; // Open in a new tab
                                                // document.body.appendChild(link);
                                                // link.click();
                                                // document.body.removeChild(link); // Remove the element after opening}
                                            } })),
                                    react_1.default.createElement("div", { className: "flex flex-row justify-start" },
                                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Send", backgroundColor: "bg-secondary" //
                                            , loading: isButtonLoading, enabled: !isButtonLoading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            if (!validate()) return [3 /*break*/, 2];
                                                            setIsButtonLoading(true);
                                                            return [4 /*yield*/, (0, send_generic_email_1.send_generic_email)({
                                                                    to: "".concat(process.env.CONTACT_SUPPORT_EMAIL_ADDRESS),
                                                                    subject: "Website Contact Form",
                                                                    from: "support@skylifestyle.app",
                                                                    template_id: "".concat(process.env.GENERIC_EMAIL_TEMPLATE_ID),
                                                                    data: {
                                                                        name: name,
                                                                        email: email,
                                                                        message: message,
                                                                    },
                                                                })
                                                                    .then(function (data) {
                                                                    if (data) {
                                                                        // console.log(data);
                                                                        dispatch((0, main_1.setMessageModal)({ title: "Contact Us", messages: [data === null || data === void 0 ? void 0 : data.message] }));
                                                                        setName("");
                                                                        setEmail("");
                                                                        setMessage("");
                                                                        setEmailError("");
                                                                        setMessageError("");
                                                                        setNameError("");
                                                                    }
                                                                })
                                                                    .finally(function () {
                                                                    setIsButtonLoading(false);
                                                                })];
                                                        case 1:
                                                            _a.sent();
                                                            _a.label = 2;
                                                        case 2: return [2 /*return*/];
                                                    }
                                                });
                                            }); } })))))),
                    react_1.default.createElement("div", { className: "flex flex-col lg:flex-row gap-4 justify-evenly" },
                        react_1.default.createElement("div", { className: "flex flex-row gap-2 justify-center items-center" },
                            react_1.default.createElement("div", { className: "flex flex-col text-tertiary bg-secondary rounded-full p-2" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faEnvelope })),
                            react_1.default.createElement("div", { className: "flex flex-col" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Customer Support", bold: true }),
                                react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: process.env.CONTACT_SUPPORT_EMAIL_ADDRESS, size: "small", textColor: "text-primary", onClick: function () {
                                        window.open("mailto:".concat(process.env.CONTACT_SUPPORT_EMAIL_ADDRESS, "?subject=Website Enquiry Form"), "_blank");
                                    } }))),
                        react_1.default.createElement("div", { className: "flex flex-row gap-2 justify-center items-center" },
                            react_1.default.createElement("div", { className: "flex flex-col text-tertiary bg-secondary rounded-full p-2" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faPhone })),
                            react_1.default.createElement("div", { className: "flex flex-col" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Customer Support", bold: true }),
                                react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: process.env.CONTACT_SUPPORT_PHONE_NUMBER, size: "small", textColor: "text-primary", onClick: function () {
                                        window.open("tel:".concat(process.env.CONTACT_SUPPORT_PHONE_NUMBER), "_blank");
                                    } })))))),
            react_1.default.createElement("div", { className: "absolute top-0 w-full -z-10" },
                react_1.default.createElement("div", { className: "h-72 bg-primary" }),
                react_1.default.createElement("div", { className: "-mt-[1px]" },
                    react_1.default.createElement("svg", { viewBox: "0 0 20 1.5", xmlns: "http://www.w3.org/2000/svg" },
                        react_1.default.createElement("path", { d: "M 0 0 L 20 0 Q 10 3 0 0", fill: colors_config_1.default.primary })))))));
};
exports.ContactUsPage = ContactUsPage;
